module.exports = __webpack_public_path__ + "static/media/benedict-1.bcafd294.jpg";